package ui.home

import com.essntl.uikit.components.icons.EsIcons
import core.config.FeatureConfig

enum class NavSidebarItem(
    val iconRes: String,
    val title: String,
    val isEnabled: () -> Boolean = { true },
) {
    Dashboard(
        iconRes = EsIcons.Home,
        title = "Home",
        isEnabled = { FeatureConfig.hasHome },
    ),
    Services(
        iconRes = EsIcons.Service,
        title = "Services",
        isEnabled = { FeatureConfig.hasServices },
    ),
    Proposals(
        iconRes = EsIcons.Proposal,
        title = "Proposals",
        isEnabled = { FeatureConfig.hasProposals },
    ),
    Itineraries(
        iconRes = EsIcons.Itinerary,
        title = "Itineraries",
        isEnabled = { FeatureConfig.hasItineraries },
    ),
    Concierge(
        iconRes = EsIcons.Concierge,
        title = "Concierge",
        isEnabled = { FeatureConfig.hasConcierge },
    ),
    Tasks(
        iconRes = EsIcons.Task,
        title = "Tasks",
        isEnabled = { FeatureConfig.hasTasks },
    ),
    Clients(
        iconRes = EsIcons.Travelers,
        title = "Travellers",
        isEnabled = { FeatureConfig.hasCrm },
    ),
    Messages(
        iconRes = EsIcons.Messages,
        title = "Messages",
        isEnabled = { FeatureConfig.hasWhatsapp },
    ),
    CRM(
        iconRes = EsIcons.Suppliers,
        title = "Contacts",
        isEnabled = { FeatureConfig.hasCrm },
    ),
    Settings(
        iconRes = EsIcons.Settings,
        title = "Settings",
    ),
}

fun getNavSidebarItems(): List<NavSidebarItem> {
    return NavSidebarItem.entries.filter { it.isEnabled() }
}